import * as yup from "yup";
import { EMAIL_REGEX } from "constants/common";

const validationSchema = yup.object().shape({
  function_name: yup.string().required("Report name is required."),
  subject: yup.string().required("Email subject is required."),

  frequency: yup.object().required("Frequency is required.").nullable(),

  recipients: yup
    .string()
    .required("At least one recipient is required.")
    .test("is-csv-emails", "One or more email addresses are invalid.", (value) => {
      if (!value) return false;

      const emails = value.split(",").map((email) => email.trim());
      return emails.every((email) => EMAIL_REGEX.test(email));
    }),

  sql: yup.string().required("SQL query is required."),

  startingOn: yup
    .date()
    .typeError("Please enter a valid date")
    .required("Start date is required.")
    .nullable(),

  status: yup.object().nullable(),
});

export default validationSchema;
